import React, { useRef, useEffect } from "react";

// Lightweight canvas: floating translucent TPU granules with subtle depth.
export function GranuleField({ density = 26 }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let raf, w, h, dpr;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const particles = [];
    const colors = ["rgba(226,97,28,", "rgba(34,36,40,", "rgba(22,24,29,"];

    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();

    for (let i = 0; i < density; i++) {
      particles.push({
        x: Math.random() * w, y: Math.random() * h,
        r: 6 + Math.random() * 18, z: 0.3 + Math.random() * 0.7,
        vy: 0.08 + Math.random() * 0.22, vx: (Math.random() - 0.5) * 0.18,
        rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.01,
        c: colors[Math.floor(Math.random() * colors.length)],
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.y -= p.vy; p.x += p.vx; p.rot += p.vr;
        if (p.y < -30) { p.y = h + 30; p.x = Math.random() * w; }
        if (p.x < -30) p.x = w + 30; if (p.x > w + 30) p.x = -30;
        const alpha = 0.10 + p.z * 0.22;
        ctx.save();
        ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        const grad = ctx.createRadialGradient(-p.r * 0.3, -p.r * 0.3, p.r * 0.1, 0, 0, p.r);
        grad.addColorStop(0, p.c + (alpha + 0.15) + ")");
        grad.addColorStop(1, p.c + alpha * 0.4 + ")");
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.ellipse(0, 0, p.r, p.r * 0.78, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      raf = requestAnimationFrame(draw);
    };
    if (!reduce) draw(); else draw() && cancelAnimationFrame(raf);
    window.addEventListener("resize", resize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, [density]);

  return <canvas ref={ref} className="absolute inset-0 w-full h-full" aria-hidden="true" data-testid="granule-canvas" />;
}
